






























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const categroy = namespace("categroy");
//递归判断是否有子节点选中
const checkChildCheck = function(data: Array<any> = []): boolean {
  return data.some(item => {
    if (item.checked || item.indeterminate) {
      return true;
    } else if (item.childNodes) {
      return checkChildCheck(item.childNodes);
    } else {
      return false;
    }
  });
};
// 设置所有父节点半选中
function setHalfParent(code: string): void {
  const $tree: any = this.$refs.tree;
  let node = $tree.getNode(code);
  if (!node) {
    return;
  }
  if (!node.checked) node.indeterminate = true;

  if (node.data.categoryParentCode && node.data.categoryParentCode !== "-1") {
    return setHalfParent.apply(this, [node.data.categoryParentCode]);
  }
}
//取消选中 状态后 往上遍历 修改 父节点的选中状态
function removeHalfParent(code: string): void {
  const $tree: any = this.$refs.tree;
  let node = $tree.getNode(code);
  if (!node) return;
  //是否有其他子节点选中，有的话就是半选中状态
  if (node.childNodes) {
    if (!checkChildCheck(node.childNodes)) node.indeterminate = false;
  }

  //如果有父节点 向上遍历 判断 父节点是否还有其他子节点是选中状态
  if (node.data.categoryParentCode && node.data.categoryParentCode !== "-1") {
    return removeHalfParent.apply(this, [node.data.categoryParentCode]);
  }
}
@Component({})
export default class selectTree extends Vue {
  selectData: Array<any> = [];
  //绑定tree 的 数据
  input1: Array<any> = [];
  //所有已加载的 tree 的节点 降维之后的
  flatDataList: Array<any> = [];
  loading: boolean = true;
  halfChecked: Array<any> = [];
  visible = false;
  //选中的数据不含label 只含code
  @Prop({ default: () => [] })
  valueData: Array<any>;
  // //半选中的code list
  // @Prop({ default: () => [] })
  // halfChecked: any;
  //选中的数据 含label
  @Prop({ default: () => [] })
  checkedData: Array<any>;
  @Watch("valueData")
  onValueDataChange(val, oldVal): void {
    if (val !== this.input1) {
      this.input1 = val;
      const $tree: any = this.$refs.tree;
      $tree.setCheckedKeys(val);
    }
  }
  @Watch("input1")
  onInputChange(val, oldVal): void {
    this.$emit("update:valueData", this.input1);
  }
  @Watch("checkedData")
  onCheckedDataChange(val): void {
    this.selectData = [...this.checkedData];
    if (this.valueData.length) {
      this.initHalfChecked();
    }
  }
  @categroy.Action queryCategory;
  mounted() {
    this.selectData = [...this.checkedData];
    if (this.valueData.length) {
      this.initHalfChecked();
    }
  }
  initHalfChecked() {
    this.checkedData.forEach(item => {
      const path = item.categoryPath.split(">");
      if (path.length > 1) {
        path.pop();
        this.halfChecked = [...this.halfChecked, ...path];
      }
    });
    this.setHalfChecked();
  }
  async loadNode(node, resolve) {
    let result: Array<any> = [];
    if (node.level === 0) {
      result = await this.queryCategory({
        categoryCode: "-1",
        isSelector: true
      });
      this.loading = false;
    } else {
      if (node.data.children && node.data.children.length) {
        result = node.data.children;
      } else {
        result = await this.queryCategory({
          categoryCode: node.data.categoryCode,
          isSelector: true
        });
      }
    }
    const checkedData = result.map(item => item.categoryCode);
    this.flatDataList = [...this.flatDataList, ...checkedData];
    //加载了tree 之后 判断 是否有半选中的数据在里面

    setTimeout(() => {
      this.setHalfChecked();
    }, 200);
    return resolve(result);
  }
  handleCheckChange(data, checked, indeterminate) {
    // 勾选
    if (checked && !this.input1.includes(data.categoryCode)) {
      this.input1.push(data.categoryCode);
      this.handleSelected({
        categoryCode: data.categoryCode,
        categoryName: data.categoryName
      });
      // 选中之后要设置 父级半选中状态

      data.categoryParentCode &&
        data.categoryParentCode !== "-1" &&
        setHalfParent.apply(this, [data.categoryParentCode]);
    } else if (!checked && !indeterminate) {
      //取消选中

      const index = this.input1.findIndex(item => item === data.categoryCode);

      this.input1.splice(index, 1);
      this.handleCancel(data.categoryCode);
      //以下方法调用顺序不能变
      if (this.halfChecked.includes(data.categoryCode)) {
        const $tree: any = this.$refs.tree;
        let node = $tree.getNode(data.categoryCode);
        node.indeterminate = true;
      } else {
        //是否有child选中，如果有就要显示为Half 状态
        data.haveChildren && this.isHasChildChecked(data.categoryCode);
      }
      //向上遍历 是否取消 父级半选中状态
      removeHalfParent.apply(this, [data.categoryParentCode]);
    }
    // console.log(this.input1, 987);
    this.$emit("update:valueData", this.input1);
  }

  isHasChildChecked(code) {
    const $tree: any = this.$refs.tree;
    let node = $tree.getNode(code);
    let result = false;
    if (node.childNodes) {
      result = checkChildCheck(node.childNodes);
      if (result) {
        node.indeterminate = true;
      }
    }
  }
  setHalfChecked() {
    this.flatDataList.forEach(item => {
      if (this.halfChecked.includes(item)) {
        const $tree: any = this.$refs.tree;
        let node = $tree.getNode(item);

        if (!node.checked) {
          node.indeterminate = true;
        }
      }
    });
  }
  handleSelected({ categoryCode, categoryName }) {
    this.selectData.push({ categoryCode, categoryName });
  }
  handleCancel(code) {
    this.selectData = this.selectData.filter(
      item => item.categoryCode !== code
    );
    //取消勾选的时候 要删掉原始数据半选中状态
    let b = this.checkedData.map(item => item.categoryCode);
    b.forEach((item, index) => {
      if (!this.input1.includes(item)) {
        let c = this.checkedData[index];
        let d = c.categoryPath.split(">");
        if (d.length > 1) {
          d.pop();
          this.halfChecked = this.halfChecked.filter(item => {
            return !d.includes(item);
          });
        }
      }
    });
  }
  toggleTree() {
    this.visible = !this.visible;
  }
}
